import { Component } from '@angular/core';

@Component({
  selector: 'lib-ngx-web-app',
  template: `
    <p>
      ngx-web-app works!
    </p>
  `,
  styles: [
  ]
})
export class NgxWebAppComponent {

}
